require('./component/buy');
require('./component/slideshow');

const tables = require('./component/tables');

$('.table-buyers-guide').dataTable({
  "language": tables.getLanguage(),
  "responsive": true,
  "lengthChange": false,
  "pageLength": 20,
  "pagingType": "numbers",
  'columnDefs': [

    {
      targets: 4,
      visible: false,
    }

  ]
})

$('.table-convertions').dataTable({
  "language": tables.getLanguage(),
  "responsive": true,
  "lengthChange": false,
  "pageLength": 15,
  "pagingType": "numbers",
  'columnDefs': [
    {
      targets: 2,
      visible: false,
    }
  ],
  'order': [
    [2, 'asc'],
    [1, 'asc'],
    [0, 'asc'],
  ],
  'columns': [
    null,
    {
      width: '80%',
    }
  ],
  rowGroup: {
    dataSrc: 2,
    className: 'text-muted text-stronger',
  }
})


$('#share-url-copy').click(function(){
  $('#share-url')[0].select();
  document.execCommand("copy");
});



$(".navigation-button").click(function(e) {
  e.preventDefault();
  var section = $($(this).attr('href'));
  if(!section) return;
  $('html, body').animate({
    scrollTop: section.offset().top - 53.84
  }, 500, 'swing');
});


var thumbnails = {

  displace: function(clicker) {
    $('.thumb-control').css('pointer-events', 'none');

    var direction = $(clicker).hasClass('thumb-next') ? 1 : -1;

    const view = $('.thumb-list')[0];

    $('.thumb-list').animate({ scrollLeft: view.scrollLeft + (view.offsetWidth * direction) }, 200, function() {
      $('.thumb-control').css('pointer-events', 'initial');
      if(!view.scrollLeft)
        $('.thumb-prev').addClass('d-none').removeClass('d-flex');
      else
        $('.thumb-prev').removeClass('d-none').addClass('d-flex');

      if(view.scrollLeft + view.offsetWidth == view.scrollWidth)
        $('.thumb-next').addClass('d-none').removeClass('d-flex');
      else
        $('.thumb-next').removeClass('d-none').addClass('d-flex');
    })


  },

  init: function() {
    $('.thumb-control').click(function(event) {
      thumbnails.displace(this);
    });

    $('.thumb-list .hover-pointer').click(function(event) {
      var imgparent = $('.main-img').parent();
      $('.zoom-frame').css('pointer-events', 'none');
      imgparent.append(`
        <div class="bg-white position-absolute" style="top:0;left:0;right:0;bottom:0;opacity:0.5;"></div>
      `);

      $('.thumb-list .hover-pointer').removeClass('active');
      $(this).addClass('active');

      $('.main-img').attr('src', $(this).find('img').attr('src').replace('/sm/', '/xl/')).unbind('load').bind('load', function() {
        $('.zoom-frame').css('pointer-events', 'initial');
        imgparent.find('.bg-white.position-absolute').remove();
        $('#modal-preview img').attr('src', $('.thumb-list .hover-pointer.active img').attr('src').replace('/sm/', '/xl/'));
      });
    });

    $('.preview-prev, .preview-next').click(function(event) {
      $('#modal-preview').css('pointer-events', 'none');
      $('#modal-preview .modal-body .position-relative').append(`
        <div class="bg-white position-absolute" style="top:0;left:0;right:0;bottom:0;opacity:0.5;"></div>
      `);

      thumbnails.position += $(this).hasClass('.preview-prev') ? -1 : 1;

      var length = $('.thumb-list .hover-pointer').length;

      thumbnails.position = thumbnails.position >= length ? 0 : (thumbnails.position < 0 ? length : thumbnails.position);

      var img = new Image();
      img.src = $($('.thumb-list .hover-pointer')[thumbnails.position]).find('img').attr('src').replace('/sm/', '/xl/');

      img.onload = function() {
        $('#modal-preview').css('pointer-events', 'initial');
        $('.modal-body .position-relative').find('.bg-white.position-absolute').remove();
      }

      $('#modal-preview img').attr('src', img.src);
    });

    $('#modal-preview').on('show.bs.modal', function(event) {
      thumbnails.position = $('.thumb-list .hover-pointer.active').index();
    }).on('hidden.bs.modal', function(event) {
      var src = $('.thumb-list .hover-pointer.active img').attr('src');
      if(src)
        $('#modal-preview img').attr('src', src.replace('/sm/', '/xl/'));
    });
  }

}
thumbnails.init();


zoom = {
  init: function() {

    $('.zoom-frame').hover(function() {
      if($(window).width() < 751) return;


      $('.product-container').css('min-height', $('.product-container').outerHeight() + 'px');

      zoom.img = new Image();
      zoom.img.src = $('.main-img').attr('src');

      var perx = this.offsetWidth  / (zoom.img.width  / 100);
      var pery = this.offsetHeight / (zoom.img.height / 100);

      $(this).append(`<div class="zoom-zone position-absolute" style="width: ${perx}%; height: ${perx}%;pointer-events:none; outline: 2px solid #888; background-color: #444; opacity: 0.3"></div>`);
      $('.product-content').hide();
      $('.zoom').show();

      $('.zoom-img').attr('src', zoom.img.src);

    }, function() {
      $(this).find('.zoom-zone').remove();
      $('.product-content').show();
      $('.zoom').hide();
    });

    $('.zoom-frame').mousemove(function(event) {
      if($(window).width() < 751) return;

      var bounds = $('.zoom-frame')[0].getBoundingClientRect()
      var zone = $('.zoom-zone');

      var posx = event.clientX   - bounds.x - (zone.width()  / 2);
      var posy = event.clientY   - bounds.y - (zone.height() / 2);

      var perx = (posx / (bounds.width  / 100)) * (zoom.img.width  / 100);
      var pery = (posy / (bounds.height / 100)) * (zoom.img.height / 100);

      zone.css({
        left: posx,
        top: posy
      });

      $('.zoom-img').css({
        transform: `translate(-${perx}px, -${pery}px)`,
      });
    });

  }
}
zoom.init();


media = {

  progress: 0,
  top:  0,
  left: 0,
  tx  : 0,
  ty  : 0,
  curzoom: 0,

  play: function() {

    if(!$('#media360').length) return;

    var reference = $('.media-holder .img-fluid.reference').addClass('hidden').attr('src').split('4.webp')[0];

    $('.media-holder .bar-holder').css({'background-color': 'rgba(255, 255, 255, 0.995)'});

    for (var i = 0; i < media.max_size; i++) {
      $('.media-frames').append(`<img src="${reference}${i}.webp" class="position-absolute media-frame d-none" style="top:0;left:0;width: 100%;height:100%; pointer-events: none">`);
    }

    for (var i = 0; i < media.max_size; i++) {

      var img = new Image();

      img.onload = function() {
        $('.media-frame').removeClass('active');
        $('.media-frame').eq(media.progress).removeClass('d-none').addClass('active');

        media.progress++;
        $('.media-holder .bar-progress').text(`${parseInt(media.progress / ((media.max_size - 1) / 100))}%`);

        if(media.progress == media.max_size - 1){
          media.progress = 0;
          $('.media-frame').removeClass('active');
          $('.media-frame').eq(media.progress).removeClass('d-none').addClass('active');

          $('.media-holder .bar-holder').remove();
          $('.media-controls, .media-frame').removeClass('hidden');
          // $('.media-btn-play').click();

          var down = $('.media-holder').data('controls') == 'mobile' ? 'touchstart' : 'pointerdown';
          var up   = $('.media-holder').data('controls') == 'mobile' ? 'touchend touchleave' : 'pointerup pointerleave';

          $('.media-holder').on(down, media.mediadown).on(up, media.mediaup);

          $('.media-frame').addClass('d-none');
          $('.media-btn-play').click();

          $('.media-holder').on('wheel', function(event) {
            event.preventDefault();

            var value = parseInt($('.zoom-bar').val()) + (event.originalEvent.deltaY > 0 ? -10 : 10);
            $('.zoom-bar').val(value);
            if(value >= 0 && value <= 200)
              $('.zoom-bar').trigger('input')


          });
        }

      }
      
      img.src = `${reference}${i}.webp`;
    }

  },

  clampImage: function(timing = 100) {

    var a = $('.media-holder')[0].getBoundingClientRect();
    var b = $('.media-frame.active')[0].getBoundingClientRect();

    var bounds = {};

    if(b.x > a.x)
      bounds.left = 0;
    else if(b.right < a.right)
      bounds.left = b.left - a.left + a.right - b.right;
    
    if(b.y > a.y)
      bounds.top = 0;
    else if(b.bottom < a.bottom)
      bounds.top = b.top - a.top + a.bottom - b.bottom;


    $('.media-frame.active').animate(bounds, timing, function() {
      media.left  = b.x > a.x || b.right  < a.right  ? bounds.left  : media.left + media.tx;
      media.top   = b.y > a.y || b.bottom < a.bottom ? bounds.top   : media.top  + media.ty;
    });
    $('.media-frame').not('.active').css(bounds);

  },

  mediadown: function() {
    media.dragging = true;
    media.x = event.pageX ? event.pageX : event.touches[0].pageX; 
    media.y = event.pageY ? event.pageY : event.touches[0].pageY;
    var move = $('.media-holder').data('controls') == 'mobile' ? 'touchmove' : 'pointermove';
    $(this).bind(move, media.moving);
  },

  mediaup: function() {
    if(media.dragging) media.clampImage();
    var move = $('.media-holder').data('controls') == 'mobile' ? 'touchmove' : 'pointermove';
    $(this).unbind(move, media.moving);
    media.dragging = false;
  },

  moving: function(event) {
    event.preventDefault();
    media.tx  = (event.pageX ? event.pageX : event.touches[0].pageX) - media.x;
    media.ty  = (event.pageY ? event.pageY : event.touches[0].pageY) - media.y;

    var tx = media.left + media.tx;
    var ty = media.top  + media.ty;

    $('.media-frame').css({
      left: `${tx}px`,
      top:  `${ty}px`,
    });

  },

  init: function(max_size) {
    media.max_size = max_size;

    $('.media-start-button').click(function(event) {
      event.preventDefault();
      $('.media-holder .media-start').remove();
      $('.media-spinner').show();
      media.play();
      event.stopPropagation();
    });

    $('.media-bar').on('mousedown touchstart', function(event) {
      if(media.playing) $('.media-btn-play i').toggleClass('fa-play fa-pause');
      clearInterval(media.playing);
      media.playing = null;
    });

    $('.media-bar').on('input', function(event) {
      $('.media-frame').addClass('d-none').removeClass('active');
      $('.media-frame').eq($(this).val()).removeClass('d-none').addClass('active');
    });

    $('.media-btn-play').click(function(event) {
      $(this).find('i').toggleClass('fa-play fa-pause');

      if(media.playing){
        clearInterval(media.playing)
        media.playing = null;
      }
      else{
        media.playing = setInterval(function() {
          var current = parseInt($('.media-bar').val()) + 1;
          current = current > media.max_size - 1 ? 0 : (current < 0 ? media.max_size - 1 : current);
          $('.media-bar').val(current).trigger('input');
        }, 100);
      }

    });

    $('.zoom-bar').on('input', function (event) {
      var increment = parseInt($(this).val());

      $('.media-holder').toggleClass('hover-move', increment > 0);

      var direction = increment < media.curzoom ? 1 : -1;

      var offset = Math.abs(increment - media.curzoom);

      media.left += direction * (offset / 2) * ($('.media-holder').width() / 100);
      media.top  += direction * (offset / 2) * ($('.media-holder').height() / 100);

      $('.media-frame').css({
        width:  `calc(100% + ${increment}%)`,
        height: `calc(100% + ${increment}%)`,
        left: `${media.left}px`,
        top:  `${media.top}px`,
      });

      media.curzoom = increment;

      media.tx = 0; media.ty = 0;
      media.clampImage(0);

    });

    $('.media-holder').on('mousedown touchstart', function(event) {
      $('.media-btn-zoom').dropdown('hide');
    });
  }
}

var max_size = parseInt($('.custom-range.media-bar').attr('max')) + 1;

media.init(max_size);



const exchange = {

  confirm: false,

  init: function() {

    $('#exchange_form').submit(function() {
      if(!exchange.confirm){
        $('.modal-confirm').modal('show');
        event.preventDefault();
      }
    });

    $('.modal-confirm-btn').on('click', function() {
      $(this).closest('.modal').modal('hide');
      exchange.confirm = true;
      $('#exchange_form').submit();
    });
  }
}

exchange.init();